module.exports = __webpack_public_path__ + "img/step-by-step.49dfa0ef.svg";